import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack, Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { setFilterPanelView } from './store/documentViewerReducer';

export function FilterDocuments(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const closeFilter = () => {
        dispatch(setFilterPanelView({ visible: false }));
    };

    return (
        <div>
            <Accordion>
                <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                    <AccordionSummary expandIcon={<ArrowDropDownIcon />} style={{ padding: '0px 0px 0px 10px' }}>
                        <Stack direction="row" alignItems="center" gap="8px" width={'280px'}>
                            <Typography component="span">{t('Filters')}</Typography>
                            <div>22</div>
                        </Stack>
                    </AccordionSummary>
                    <Box onClick={closeFilter} style={{ cursor: 'pointer', width: '30px', height: '24px' }}>
                        <CloseIcon />
                    </Box>
                </Stack>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo
                        lobortis eget.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                    <Typography component="span">{t('Folders')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo
                        lobortis eget.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
